import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import HttpClientXml from "../../../utils/HttpClientXml";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import Select from "react-select";
import { saveAs } from "file-saver";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

const options = [
  { value: true, label: "True", color: "green" },
  { value: false, label: "False", color: "red" },
];

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: state.data.color,
  }),
};

const ManageUser = () => {
  const [allData, setAllData] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [filteredInformation, setFilteredInformation] = useState([]);
  const [totalDeviceLogin, setTotalDeviceLogin] = useState("");

  const [userDownloadDocumentStatus, setUserDownloadDocumentStatus] =
    useState(null);

  const [designations, setDesignations] = useState([]);
  const [roles, setRoles] = useState([
    {
      _id: 1,
      name: "sales",
    },
    {
      _id: 2,
      name: "survey",
    },
    {
      _id: 3,
      name: "telecalling",
    },
    {
      _id: 4,
      name: "data entry",
    },
    {
      _id: 5,
      name: "branch manager",
    },
  ]);

  const [uploading, setUploading] = useState(false);
  const [cities, setCities] = useState([]);

  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");

  const initialFormData = {
    email: "",
    fullName: "",
    password: "",
    city: "",
    companyName: "",
    address: "",
    mobileNo: "",
    workExpYear: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const [editID, setEditID] = useState("");
  const [selectedCityID, setSelectedCityID] = useState("");

  const handleChange = (e) => {
    e.preventDefault();

    let name = e.target.name;
    let value = e.target.value;

    if (name === "phoneNo" || name === "salary") {
      value = parseInt(value);
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleFileUpload = async (e) => {
    setUploading(true);
    const file = e.target.files[0];
    const data = new FormData();
    data.append("image", file);

    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      if (res?.image) {
        setFormData({ ...formData, [e.target.name]: res.image });
        setUploading(false);
      }
    } catch (error) {
      toast.error(`Upload Failed.`);
      console.error(`Error uploading:`, error);
    }
  };

  const fetchAllData = async () => {
    try {
      const response = await HomeService.getUsers();
      console.log("GTS142A", response?.data, userCity);

      const formattedData = response?.data.map((item, index) => ({
        id: item._id,
        sln: index + 1,
        cityName: item?.city?.name,
        fullName: item?.fullName,
        city: item?.city?._id,
        email: item?.email,
        mobileNo: item?.mobileNo,
        workExpYear: item?.workExpYear,
        companyName: item?.companyName,
        maxDeviceLogin: item?.maxDeviceLogin,
        deviceCount: item?.deviceCount,
        address: item?.address,
        visiblePassword: item?.visiblePassword,
        action: (
          <>
            <span title="Edit" onClick={() => handleEdit(item)}>
              <i
                className="fa-solid fa-pen-to-square"
                style={{
                  cursor: "pointer",
                  padding: "5px",
                  marginRight: "5px",
                  fontSize: "1.5em",
                  color: "rgb(133, 218, 79)",
                  backgroundColor: "#E9F3F7",
                }}
              ></i>
            </span>

            <span title="Delete" onClick={() => handleDelete(item._id)}>
              <i
                className="fa-solid fa-trash"
                style={{
                  cursor: "pointer",
                  padding: "5px",
                  marginRight: "5px",
                  fontSize: "1.5em",
                  color: " red",
                  backgroundColor: "#E9F3F7",
                }}
              ></i>
            </span>
          </>
        ),
      }));

      if (userCity) {
        setAllData(
          formattedData.filter((item) => item?.city === userCity) || [],
        );
      } else {
        setAllData(formattedData || []);
      }

      console.log("DSE152", formattedData, "yt44");
    } catch (error) {
      console.error("Error fetching Staffs:", error);
    }
  };

  // Fetch cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.data) {
        // setCities(res.data);
        if (userCity) {
          setCities([res.data.find((item) => item._id === userCity)]);
          setFormData({ ...formData, city: userCity });
        } else {
          setCities(res.data);
        }
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  const fetchUserDownloadDocumentStatus = async () => {
    try {
      const res = await HomeService.getUserDownloadDocumentStatus();
      if (res?.data) {
        setUserDownloadDocumentStatus(res?.data?.visibilityAcess);
        console.log("status", res?.data);
      }
    } catch (error) {
      console.error("Error fetching Status:", error);
    }
  };

  // Fetch Designations
  const fetchDesignations = async () => {
    try {
      const res = await HomeService.getDesignations();
      if (res?.data) {
        setDesignations(res.data);
      }
    } catch (error) {
      console.error("Error fetching designations:", error);
    }
  };

  useEffect(() => {
    fetchAllData();
    fetchCities();
    fetchUserDownloadDocumentStatus();
    // fetchDesignations();
  }, []);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Deleting User...",
      text: "Are you sure you want to delete this User record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "No, not sure!",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteUser(id);
        if (res?.status) {
          Swal.fire("Deleted!", "User record has been deleted.", "success");
          fetchAllData();
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete User record.", "error");
      }
    }
  };

  const handleEdit = (data) => {
    setEditID(data?._id || "");
    console.log("HTE202", data);
    setTotalDeviceLogin(data?.maxDeviceLogin);
    setFormData({
      email: data.email,
      fullName: data.fullName,
      password: data.visiblePassword,
      city: data.city._id,
      companyName: data.companyName,
      // maxDeviceLogin: data?.maxDeviceLogin,
      address: data.address,
      mobileNo: data.mobileNo,
      workExpYear: data.workExpYear,
      ytLink: data?.ytLink,
      fbLink: data?.fbLink,
      instaLink: data?.instaLink,
    });

    const editSection = document.getElementById("edit-section");
    if (editSection) {
      editSection.scrollIntoView({
        behavior: "smooth", // Smooth scrolling
        block: "start", // Align to the top of the section
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("DRE225", formData);
    // const { image, password, ...formData } = formData;
    console.log("DRE225", formData);
    // return
    try {
      const res = await HomeService.updateUser(editID, formData);
      if (res?.status) {
        fetchAllData();
        setEditID(null);
        toast.success("User data updated successfully!");
      }
    } catch (error) {
      toast.error("Failed to update User.");
      console.error("Error updating User:", error);
    }
  };

  const columns = [
    { name: "Sl#", selector: (row) => row.sln, sortable: true },
    { name: "Full Name", selector: (row) => row.fullName, sortable: true },
    { name: "Email", selector: (row) => row.email, wrap: true },
    { name: "Mobile#", selector: (row) => row.mobileNo, sortable: true },
    { name: "City", selector: (row) => row.cityName },
    { name: "Address", selector: (row) => row.address },
    { name: "Company Name", selector: (row) => row.companyName },
    {
      name: "Work Experience",
      selector: (row) => row.workExpYear,
      sortable: true,
      center: true,
    },
    {
      name: "Max Device Login",
      selector: (row) => row?.maxDeviceLogin,
      center: true,
    },
    {
      name: "Activate device Count",
      selector: (row) => row?.deviceCount || "",
      center: true,
    },
    {
      name: "Action",
      selector: (row) => row.action,
      sortable: true,
      style: { textAlign: "center" },
    },
  ];

  const downloadPDF = () => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(16);
    doc.text("Manage User Data", 14, 20);

    // Table Columns
    const tableColumn = [
      "Sl#",
      "Full Name",
      "Email",
      "Mobile#",
      "City",
      "Address",
      "Company Name",
      "Work Experience",
    ];

    // Table Rows
    const tableRows = allData.map((row) => [
      row.sln,
      row.fullName,
      row.email,
      row.mobileNo,
      row.cityName,
      row.address,
      row.companyName,
      row.workExpYear,
    ]);

    // AutoTable (plugin function call)
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 30,
      styles: { fontSize: 10 },
      headStyles: { fillColor: [41, 128, 185] },
    });

    // Save PDF
    doc.save("manage-users.pdf");
  };

  const downloadExcel = () => {
    const worksheetData = allData.map((row) => ({
      "Sl#": row.sln,
      "Full Name": row.fullName,
      Email: row.email,
      "Mobile#": row.mobileNo,
      City: row.cityName,
      Address: row.address,
      "Company Name": row.companyName,
      "Work Experience": row.workExpYear,
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "manage-users.xlsx");
  };

  const filter = () => {
    console.log("users", allData); // users = তোমার ডেটা array
    const text = filterText.toLowerCase();

    const filteredData = allData.filter((item) => {
      const nameMatch = item?.fullName?.toLowerCase().includes(text);
      const emailMatch = item?.email?.toLowerCase().includes(text);
      const companyMatch = item?.companyName?.toLowerCase().includes(text);
      const addressMatch = item?.address?.toLowerCase().includes(text);
      const majorLocalityMatch = item?.majorLocality
        ?.toLowerCase()
        .includes(text);
      const businessFieldMatch = item?.businessField
        ?.toLowerCase()
        .includes(text);

      // mobile number match (number → string)
      const mobileMatch = item?.mobileNo?.toString().includes(text);

      // city object match
      const cityMatch = item?.city?.name?.toLowerCase().includes(text);

      return (
        nameMatch ||
        emailMatch ||
        companyMatch ||
        addressMatch ||
        majorLocalityMatch ||
        businessFieldMatch ||
        mobileMatch ||
        cityMatch
      );
    });

    console.log("filteredData", filteredData);
    setFilteredInformation([...filteredData]);
  };

  useEffect(() => {
    filter();
  }, [filterText]);

  const toggleUserDownloadDocumentStatus = async (status) => {
    const data = status == "true" ? true : false;
    try {
      const res = await HomeService.updateUserDownloadDocumentStatus({
        visibilityAcess: data,
      });
      console.log("respons from put method of status", res);
      if (res?.status) {
        fetchUserDownloadDocumentStatus();

        toast.success(res?.message);
      }
    } catch (error) {
      toast.error("Failed to update Status.");
      console.error("Error updating Status:", error);
    }
  };

  const handleSubmitForMaxDeviceLimit = async () => {
    try {
      const res = await HomeService.updateMaxDeviceLogin(editID, {
        maxDeviceLogin: totalDeviceLogin,
      });
      if (res?.status) {
        toast.success(res?.message);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message);
    }
  };

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid" id="edit-section">
        <div className="mt-5">
          <h2 className="text-center" style={headLineStyle}>
            Manage User
          </h2>
          <div
            style={{
              marginBottom: "15px",
              display: "flex",
              gap: "15px",
              justifyContent: "flex-end",
            }}
          >
            <button
              style={{
                padding: "5px 10px",
                borderRadius: "5px",
                backgroundColor: "#73fc03",
                fontWeight: "600",
                border: "none",
              }}
              onClick={downloadPDF}
            >
              Download PDF ({allData?.length})
            </button>
            <button
              style={{
                padding: "5px 10px",
                borderRadius: "5px",
                backgroundColor: "#73fc03",
                fontWeight: "600",
                border: "none",
              }}
              onClick={downloadExcel}
            >
              Download Excel ({allData?.length})
            </button>
          </div>
          <div
            style={{
              marginBottom: "15px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <input
              onChange={(e) => {
                setFilterText(e?.target?.value);
              }}
              value={filterText}
              placeholder="Type to Search"
              style={{
                border: "1px solid grey",
                height: "35px",
                width: "30%",
                borderRadius: "5px",
                padding: "0 5px",
                // marginTop: "15px",
              }}
            />
            <div>
              <label
                style={{ fontSize: "18px", fontWeight: "600" }}
                htmlFor=""
              >{`User Can Download documents : `}</label>
              <select
                value={userDownloadDocumentStatus}
                onChange={(e) => {
                  // const value = e.target.value === "true";
                  setUserDownloadDocumentStatus(e.target.value);
                  toggleUserDownloadDocumentStatus(e.target.value);
                }}
                style={{ borderRadius: "5px", marginLeft: "5px" }}
              >
                <option value="true">True</option>
                <option value="false">False</option>
              </select>
              {/* <Select options={options} styles={customStyles} /> */}
            </div>
          </div>
          <section className="chartBox_area">
            {editID ? (
              <>
                <h3>View/Modify User Data</h3>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div
                      className="col-md-6 mt-3"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                      }}
                    >
                      <label>
                        Full Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="fullName"
                        value={formData?.fullName}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Full Name"
                      />
                    </div>

                    <div className="col-md-6 mt-3">
                      <label>
                        Mobile Number<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="mobileNo"
                        value={formData?.mobileNo || ""}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter mobile number"
                      />
                    </div>

                    <div
                      className="col-md-6 mt-3"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                      }}
                    >
                      <label>
                        Email Address<span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={formData?.email || ""}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Email address"
                      />
                    </div>

                    <div className="col-md-6 mt-3">
                      <label>
                        Password<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="password"
                        value={formData?.password || ""}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Password"
                      />
                    </div>

                    <div className="col-md-6 mt-3">
                      <label>
                        City<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        name="city"
                        value={formData?.city || ""}
                        onChange={(e) => handleChange(e)}
                      >
                        <option value="" disabled>
                          ---Select---
                        </option>
                        {cities.map((city) => (
                          <option key={city._id} value={city._id}>
                            {city.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 mt-3">
                      <label>Address</label>
                      <input
                        type="text"
                        className="form-control"
                        name="address"
                        value={formData?.address || ""}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter address"
                      />
                    </div>

                    <div className="col-md-6 mt-3">
                      <label>Company Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="companyName"
                        value={formData?.companyName || ""}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Company Name"
                      />
                    </div>

                    <div className="col-md-6 mt-3">
                      <label>Work Experience</label>
                      <input
                        type="text"
                        className="form-control"
                        name="workExpYear"
                        value={formData?.workExpYear || ""}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Work Experience"
                      />
                    </div>
                    <div className="col-md-6 mt-3">
                      <label>Youtube Link</label>
                      <input
                        disabled
                        type="text"
                        className="form-control"
                        name="workExpYear"
                        value={formData?.ytLink || "N/A"}
                        // onChange={(e) => handleChange(e)}
                        // placeholder="Enter Work Experience"
                      />
                    </div>
                    <div className="col-md-6 mt-3">
                      <label>Facebook Link</label>
                      <input
                        disabled
                        type="text"
                        className="form-control"
                        name="workExpYear"
                        value={formData?.fbLink || "N/A"}
                        // onChange={(e) => handleChange(e)}
                        // placeholder="Enter Work Experience"
                      />
                    </div>
                    <div className="col-md-6 mt-3">
                      <label>Instagram Link</label>
                      <input
                        disabled
                        type="text"
                        className="form-control"
                        name="workExpYear"
                        value={formData?.instaLink || "N/A"}
                        // onChange={(e) => handleChange(e)}
                        // placeholder="Enter Work Experience"
                      />
                    </div>
                    <div
                      className="col-md-6 mt-3"
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <div>
                        <label>Max Device Login</label>
                        <input
                          // style={{ width: "150%" }}
                          type="text"
                          className="form-control"
                          // name="workExpYear"
                          value={totalDeviceLogin || ""}
                          onChange={(e) => {
                            if (/^\d*$/.test(e.target.value)) {
                              setTotalDeviceLogin(Number(e.target.value));
                            }
                          }}
                          placeholder="Enter Max Device Login Number"
                        />
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary"
                        style={{
                          padding: "5px",
                          height: "40px",
                          width: "80px",
                          marginTop: "30px",
                          backgroundColor: "green",
                        }}
                        onClick={() => {
                          handleSubmitForMaxDeviceLimit();
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                  <button type="submit" className="btn btn-primary mt-3">
                    Save Changes
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary mt-3"
                    style={{ marginLeft: "11px" }}
                    onClick={() => {
                      setEditID(null);
                      fetchAllData();
                    }}
                  >
                    Cancel
                  </button>
                </form>
              </>
            ) : (
              <DataTable
                columns={columns}
                //  data={allData}
                data={filterText ? filteredInformation : allData}
                pagination
              />
            )}
          </section>
        </div>
      </div>
    </div>
  );
};

export default ManageUser;
